/**
 * Volume-to-volume conversion factors.
 * To convert: result = value * factor
 */
export const VOLUME_CONVERSIONS = [
    // ml base
    { from: 'ml', to: 'cl', factor: 0.1 },
    { from: 'ml', to: 'l', factor: 0.001 },
    { from: 'cl', to: 'ml', factor: 10 },
    { from: 'cl', to: 'l', factor: 0.01 },
    { from: 'l', to: 'ml', factor: 1000 },
    { from: 'l', to: 'cl', factor: 100 },
    // teaspoon / tablespoon
    { from: 'tsp', to: 'ml', factor: 5 },
    { from: 'ml', to: 'tsp', factor: 0.2 },
    { from: 'tbsp', to: 'ml', factor: 15 },
    { from: 'ml', to: 'tbsp', factor: 1 / 15 },
    { from: 'tsp', to: 'tbsp', factor: 1 / 3 },
    { from: 'tbsp', to: 'tsp', factor: 3 },
    // cup
    { from: 'cup', to: 'ml', factor: 240 },
    { from: 'ml', to: 'cup', factor: 1 / 240 },
    // fluid ounces
    { from: 'fl_oz', to: 'ml', factor: 29.5735 },
    { from: 'ml', to: 'fl_oz', factor: 1 / 29.5735 },
];
/**
 * Weight-to-weight conversion factors.
 * To convert: result = value * factor
 */
export const WEIGHT_CONVERSIONS = [
    { from: 'g', to: 'kg', factor: 0.001 },
    { from: 'kg', to: 'g', factor: 1000 },
    { from: 'oz', to: 'g', factor: 28.3495 },
    { from: 'g', to: 'oz', factor: 1 / 28.3495 },
    { from: 'lb', to: 'g', factor: 453.592 },
    { from: 'g', to: 'lb', factor: 1 / 453.592 },
    { from: 'lb', to: 'kg', factor: 0.453592 },
    { from: 'kg', to: 'lb', factor: 1 / 0.453592 },
    { from: 'oz', to: 'lb', factor: 1 / 16 },
    { from: 'lb', to: 'oz', factor: 16 },
];
//# sourceMappingURL=conversions.js.map